import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_186_reference_settlement_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "199",
      action: "navigate_modulev1/reference_settlement",
    },
    title: "Reference settlement",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "settlement_no",
            Name: "reference_settlement_summary",
            BindValue: "grid_reference_settlement",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/reference_settlement_view",
                },
                ActionType: ActionType.VIEW,
                ScreenId: "200",
                popup: true,
                tooltip: "View",
              },
            ],
            Form: {
              Name: "reference_settlement_summary",
              TableName: "",
              View: "view_reference_settlement_list",
              DisplayName: "reference_settlement_summary",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Party id",
                  BindValue: "party_id",
                  Json_Attribute: "party_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Party type",
                  BindValue: "party_type",
                  Json_Attribute: "party_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Settlement No.",
                  BindValue: "settlement_no",
                  Json_Attribute: "settlement_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Settlement date",
                  BindValue: "settlement_date",
                  Json_Attribute: "settlement_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Party name",
                  BindValue: "party_name",
                  Json_Attribute: "party_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Debit reference",
                  BindValue: "debit_reference_no",
                  Json_Attribute: "debit_reference_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Credit reference",
                  BindValue: "credit_reference_no",
                  Json_Attribute: "credit_reference_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Settlement amount",
                  BindValue: "settlement_amount",
                  Json_Attribute: "settlement_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  valueFormat: "currency",
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Remarks",
                  BindValue: "remarks",
                  Json_Attribute: "remarks",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
